export const syncUser = async (user, getToken, post, apiUrl) => {
  try {
    const access_token = await getToken();
    if (access_token) {
      const user_id = user?.sub?.split("|")[1];
      const userData = {
        user_id: user_id,
        firstname: user?.given_name,
        lastname: user?.family_name,
        user_id_sub: user?.sub,
        email: user?.email,
        created_at: new Date(),
        updated_at: new Date(),
      };
      const userDetails = await post(
        apiUrl,
        { id: user_id, userData: userData },
        access_token
      );
      return userDetails?.data?.user;
    }
  } catch (err) {
    console.error("User sync failed", err);
  }
};
